import type { BaseStoreRingData } from '../_types/types';

export const oR4DataArray: BaseStoreRingData[] = [
  {
    productKey: 'OuraRing4Silver',
    productImg: {
      src: 'lineItem/or4-silver',
      alt: 'or4_silver_product_img_alt',
    },
    lifeStyleImg: {
      src: 'store/ring-carousels/hover-images/or4-silver',
      alt: 'store_or4_silver_hover_image_alt',
    },
    finish: 'pdp_ring_color_silver_label',
    pdpPath: '/store/rings/oura-ring-4/silver',
  },
  {
    productKey: 'OuraRing4Gold',
    productImg: {
      src: 'lineItem/or4-gold',
      alt: 'or4_gold_product_img_alt',
    },
    lifeStyleImg: {
      src: 'store/ring-carousels/hover-images/or4-gold',
      alt: 'store_or4_gold_hover_image_alt',
    },
    finish: 'pdp_ring_color_gold_title',
    pdpPath: '/store/rings/oura-ring-4/gold',
  },
  {
    productKey: 'OuraRing4Stealth',
    productImg: {
      src: 'lineItem/or4-stealth',
      alt: 'or4_stealth_product_img_alt',
    },
    lifeStyleImg: {
      src: 'store/ring-carousels/hover-images/or4-stealth',
      alt: 'store_or4_stealth_hover_image_alt',
    },
    finish: 'pdp_ring_color_stealth_title',
    pdpPath: '/store/rings/oura-ring-4/stealth',
  },
  {
    productKey: 'OuraRing4RoseGold',
    productImg: {
      src: 'lineItem/or4-rose-gold',
      alt: 'or4_rose_gold_product_img_alt',
    },
    lifeStyleImg: {
      src: 'store/ring-carousels/hover-images/or4-rose-gold',
      alt: 'store_or4_rose_gold_hover_image_alt',
    },
    finish: 'pdp_ring_color_rose_gold_title',
    pdpPath: '/store/rings/oura-ring-4/rose-gold',
  },
  {
    productKey: 'OuraRing4BrushedSilver',
    productImg: {
      src: 'lineItem/or4-brushed-silver',
      alt: 'or4_brushed_silver_product_img_alt',
    },
    lifeStyleImg: {
      src: 'store/ring-carousels/hover-images/or4-brushed-silver',
      alt: 'store_or4_brushed_silver_hover_image_alt',
    },
    finish: 'product_catalog_color_brushed_silver',
    pdpPath: '/store/rings/oura-ring-4/brushed-silver',
  },
  {
    productKey: 'OuraRing4Black',
    productImg: {
      src: 'lineItem/or4-black',
      alt: 'or4_black_product_img_alt',
    },
    lifeStyleImg: {
      src: 'store/ring-carousels/hover-images/or4-black',
      alt: 'store_or4_black_hover_image_alt',
    },
    finish: 'pdp_ring_color_black_title',
    pdpPath: '/store/rings/oura-ring-4/black',
  },
];
